module.exports = __webpack_public_path__ + "img/personal-info.8868c93f.svg";